export default "__VITE_ASSET__NlMN6vfC__"